import React, { FC } from 'react';

import {
  Box,
  BoxProps,
  Heading,
  CloseButton,
  HStack,
  Stack,
  Center,
  Flex,
} from '@chakra-ui/react';
import { find } from 'lodash';
import { useLocation } from 'react-router-dom';

import { CustomTooltip } from 'components/DataDisplay/Tooltip/CustomTooltip';
import { TimeRangeButtonGroup } from 'components/DataEntry/Button/OptionsButtonGroup/TimeRangeButtonGroup';
import { ViewAllIcon } from 'components/Icons/ReactCustomIcons/ViewAllIcon';
import {
  ClockIcon,
  EditIcon,
  IMenuItemProps,
  Menu,
  modalCloseButtonIconStyles,
  OptionsIcon,
  PrimaryIconButton,
} from 'components/index';
import { reportChartTimeRangeOptions } from 'containers/Reports/ReportsDashboard/Components/ReportWidget/utils';
import { toTitleCase } from 'utils/string';

export interface IReportWidget extends BoxProps {
  onClickRemove?: () => void;
  onClickEdit: () => void;
  currentRecord: Record<string, any>;
  expandChart: boolean;
  setExpandChart: (val: boolean) => void;
  getReportingChartDetails(
    chart: Record<string, any>,
    index: number,
    timeRange: string,
  ): void;
}

export const ReportWidgetHeader: FC<IReportWidget> = props => {
  const {
    onClickRemove,
    onClickEdit,
    currentRecord,
    expandChart,
    setExpandChart,
    getReportingChartDetails,
  } = props;
  const { pathname } = useLocation();
  const isEditDashboard = pathname === '/reports/dashboard/edit';

  const menuItems: IMenuItemProps[] = [
    {
      label: 'Update chart',
      icon: <EditIcon />,
      onClick: () => onClickEdit?.(),
    },
    {
      label: 'View as Popup',
      icon: <ViewAllIcon p={0.5} />,
      onClick: () => setExpandChart(true),
    },
  ];

  return (
    <Box>
      <HStack px={3} h={'40px'} justifyContent={'space-between'} w="full">
        {!expandChart && (
          <Flex w="full">
            <Box fontSize="lg" fontWeight={600}>
              {toTitleCase(currentRecord?.name)}
            </Box>
          </Flex>
        )}
        <HStack {...(expandChart && { w: 'full', justify: 'flex-end' })}>
          <Box whiteSpace="nowrap">
            <TimeRangeButtonGroup
              options={reportChartTimeRangeOptions}
              styles={{ option: { fontSize: '13px', py: 0.5 } }}
              value={find(
                reportChartTimeRangeOptions,
                o => o.value === currentRecord?.timeRange,
              )}
              onChange={selected => {
                getReportingChartDetails(
                  currentRecord,
                  currentRecord.index,
                  selected?.value,
                );
              }}
            />
          </Box>

          {!expandChart && (
            <Menu
              menuItems={menuItems}
              buttonLabel={
                <Center h="full" pt={2}>
                  <Center boxSize={5}>
                    <OptionsIcon color="primary" />
                  </Center>
                </Center>
              }
              styles={{
                list: { py: 1, fontSize: 'sm' },
                menu: { placement: 'bottom-end' },
              }}
            />
          )}
        </HStack>
        {isEditDashboard && (
          <CloseButton
            className="non-draggable"
            {...modalCloseButtonIconStyles}
            size="sm"
            onMouseDown={e => e.stopPropagation()}
            onClick={e => {
              e.stopPropagation();
              onClickRemove?.();
            }}
          />
        )}
      </HStack>
    </Box>
  );
};
